export function uformLabelMapper<T extends { label: string }>(item: T) {
  return item.label;
}
